
import { GetMeasurementDatesProps } from './getMeasurementDate.props'; 

// Used to select a specific measurement date based on the available FMDs and CMDs
const getMeasurementDate = ({
  commonMeasurementDate,
  fallbackValue,
  measurementDates,
}: GetMeasurementDatesProps) =>
  measurementDates
    ? measurementDates.find(measurementDate => measurementDate.date === commonMeasurementDate)?.id
    : fallbackValue;

export default getMeasurementDate;
